@if (visible$ | async) {
@if (summary$ | async; as summary) {
  <button
    type="button"
    class="credits-balance-button"
    [ngClass]="summary.variation"
    [class.v2]="v2$ | async"
    (click)="open()"
    data-testid="credits-balance-button"
  >
    @if (summary.variation !== 'clear') {
      @if (v2$ | async) {
        <app-icon
          class="credits-balance-button__alert-icon"
          name="add_triangle"
          matFontSet="material-symbols-outlined"
          [size]="24"
        />
      } @else {
        <app-icon
          class="credits-balance-button__alert-icon"
          name="warning"
          matFontSet="material-symbols-outlined"
          [size]="20"
        />
      }
    }
    <span class="credits-balance-button__label">{{ 'CREDITS_BALANCE.BUTTON' | translate }}</span>
    <img class="credits-balance-button__icon" src="assets/icons/channels/whatsapp.svg" alt="WhatsApp" />
    @if (summary.alertCount > 0) {
      <span class="credits-balance-button__bubble">{{ summary.alertCount }}</span>
    }
  </button>
}
}
